export const BUSINESS_PROGRAM = 'business'
export const PERSONAL = 'personal'
export const NORMAL_CONTACT = 'normal'
